export default "__VITE_ASSET__DxA4Cy6L__"